import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { PlotOverviewMediaFile } from '@/api/rest/resources/types/plot';
import {
  DialogBodyWidget,
  DialogCloseWidget,
  DialogContentWidget,
  DialogHeaderWidget,
  DialogLayoutWidget,
} from '@/components/widgets/o/Dialog/Dialog';

import { MediaFileForm } from './MediaFileForm';

type MediaFileDialogDialogProps = {
  open: boolean;
  onClose: () => void;
  type: 'create' | 'update';
  mediaFile?: PlotOverviewMediaFile;
  plotOverviewId: string;
};

export const MediaFileDialog = ({ open, onClose, type, mediaFile, plotOverviewId }: MediaFileDialogDialogProps) => {
  const { t } = useTranslation();

  return (
    <DialogLayoutWidget open={open} onOpenChange={onClose}>
      <DialogContentWidget className='px-10 max-w-[80vw]' withXButton={false}>
        <DialogHeaderWidget className='pb-4'>
          <Stack direction='row' className='justify-between' data-testid='details-header'>
            <Stack direction='row' centerMain spacing={2}>
              <span className='typography-h3'>
                {t(`shared.mediaUpload.plotOverview.mediaUpload.dialog.header.${type}`)}
              </span>
            </Stack>
            <DialogCloseWidget />
          </Stack>
        </DialogHeaderWidget>
        <DialogBodyWidget>
          <MediaFileForm mediaFile={mediaFile} plotOverviewId={plotOverviewId} onClose={onClose} />
        </DialogBodyWidget>
      </DialogContentWidget>
    </DialogLayoutWidget>
  );
};
